<template>
    <div class="page-header">
        <div class="page-left">
            <span class="txt-bold">FMDS </span><span class="txt-bold"> 设备数据记录平台</span>
        </div>
        <div class="page-right">
            <span>{{$store.state.login.username}} </span>|
            <span>修改密码 </span>| 
            <router-link tag="span" to="/login">退出登录</router-link>
        </div>
    </div>
</template>

<script>

export default {
    name: 'PageHeader',
}
</script>
<style scoped>
.page-header {
    font-size: 0.18rem;
}
.page-header::after {
    clear: both;
    content: "";
    display: block;
    width: 0;
    height: 0;
}
.page-header .page-left,
.page-header .page-right {
    padding-top: 0.1rem;
    line-height: 0.4rem;
}
.page-header .page-left {
    float: left;
}
.page-header .page-right {
    float: right;
    font-size: 0.15rem;
}
</style>


